var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.5625C21 7.59158 16.9709 3.5625 12 3.5625C7.02908 3.5625 3 7.59158 3 12.5625C3 17.5334 7.02908 21.5625 12 21.5625C16.9709 21.5625 21 17.5334 21 12.5625Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4436 10.3431V10.2415C15.4436 9.26881 14.6552 8.48047 13.6825 8.48047H10.6855C9.51107 8.48047 8.55835 9.43181 8.55835 10.6076C8.55835 11.7822 9.51107 12.7348 10.6855 12.7348H13.3992C14.5283 12.7348 15.4448 13.6501 15.4448 14.779C15.4448 15.9095 14.5283 16.8248 13.3992 16.8248H10.3194C9.34669 16.8248 8.55835 16.035 8.55835 15.0623",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 7V18.1234",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnNavIcon);
export default __webpack_public_path__ + "static/media/earn_nav_icon.cce7ae00c2496179f563b473988ba92c.svg";
export { ForwardRef as ReactComponent };